module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADnSURBVHgB1dQ/CsIwFAbwLwGdHR0i1FHBwSP0JF6hnkA9gfYG9iR6Awf/rR0U3MwoavvME4oOraQ1IH5QKKH59T1CnoDJHmqUAIEAGqgQArQEzbs4DsUOrSmBAjhICkzEBupctbKcaOkQ4zQkHOf3oADFEvc2P1+DjAkkfgen+FLwjTX4jq3Q9OqoLazBrCVGijHyrEFuhzczYm7B0hZ7/nwLRTnL8RU3v2+QbMUGK6yQN/FmRspgHyp8VZqCIgkxsMEswPL5g6vHwxHuohkM4SjGigS/rKFmpndzkpVnozbTOuzhMH4AyvxefRLNGdYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/model-cur2.png
// module id = lrOb
// module chunks = 36